export const RegexConstants = {
    LINKEDIN_URL : /^https?:\/\/[a-z]{2,3}\.linkedin\.com\/[\w-.]{2,20}\/[\w-.\/]{2,100}$/,
    STRING_ONLY: /^[A-Za-zÀ-ÖØ-öø-ÿ0-9,\-./'":\s]*$/i,
    GITHUB_URL: /^(http(s?):\/\/)?(www\.)?github\.([a-z])+\/([A-Za-z0-9]{1,})+\/?$/i
}